<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { AgentConfigSignature, ConfigSignature, getCorUserId } from '@/api/signature';
import * as ww from '@wecom/jssdk'; 
export default {
  name: 'App',
  components: {
  },
  mounted () {
      let options = this.$route.query;
      // 页面加载完成后注册企业微信 SDK
      ww.register({
        corpId: 'wwe781a89979f09061', // 替换为你的 corpId
        agentId: 1000070, // 替换为你的 agentId
        jsApiList: ['getContext','getCurExternalContact'],
        getConfigSignature,
        getAgentConfigSignature
      });
      async function getConfigSignature() {
        // 获取签名
        const res = await ConfigSignature({url:location.href});
        const { timestamp, nonceStr, signature } = res.data;
        return { timestamp, nonceStr, signature };
      }
      async function getAgentConfigSignature() {
        // 获取签名
        const res = await AgentConfigSignature({url:location.href});
        const { timestamp, nonceStr, signature } = res.data;
        return { timestamp, nonceStr, signature };
      }
      let that = this;
      ww.getContext({
        success (res){
          if(res.entry !=="single_chat_tools"){
            that.$router.push({
              path: '/notFoundPage'
            })
          }else{
            let userId = localStorage.getItem('userId');
            if(userId||options.code){
              if(!userId){
                that.getUserInfoByCode(options.code);
              }
            }else{
              let corpId = 'wwe781a89979f09061';
              let redirect_uri = encodeURIComponent(location.origin);
              let scope = 'snsapi_base';
              let response_type = 'code';
              let agentid = 1000070;
              let url="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+corpId+"&redirect_uri="+redirect_uri+"&response_type="+response_type+"&scope="+scope+"&agentid="+agentid+"#wechat_redirect";
              window.location.href=url;
            }
          }
        },
        fail(err) {
          console.log('getContext==>',err);
        }
      })
    },
    destroyed(){
      localStorage.clear();
    },
    methods: {
      //获取当前用户的信息code
      async getUserInfoByCode(code) {
        try {
          let result = await getCorUserId({ code: code }); // 使用 await 获取数据
          let userinfo = result.data;
          if (userinfo.code === 200) {
            localStorage.setItem('userId', userinfo.userId);
          } 
        } catch (error) {
          console.error('获取用户信息失败:', error);
        }
      },
      getjssdk(){
        let that = this;
        that.title = '生效';
        ww.checkJsApi({
          jsApiList: ['getContext','getCurExternalContact'],
          success(res) {
            that.title = JSON.stringify(res)
          },
          fail(err) {
            that.title = JSON.stringify(err)
          }
        })
        
      },
     
      
    }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  min-height: 100vh;
  background-color: #F4F4F4;
}
</style>
